module.exports = __webpack_public_path__ + "media/images/promotions/start-btn-6de3470143f394fa24d750cd2875be0e.svg";